import {ready} from "./ready";

ready(() => {

	const {
		      computePosition,
		      offset,
		      autoUpdate,
		      flip,
		      shift
	      } = window.FloatingUIDOM;

	const imageWithHotspots = document.querySelector(".image_with_hotspots");

	if (imageWithHotspots)
	{
		const hotspots             = Array.from(imageWithHotspots.querySelectorAll('.hotspot'));
		const toggleBtn            = imageWithHotspots.querySelector('.image_with_hotspots__autoplay');
		const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		const tooltipOffset        = 36;

		// state
		let intervalId         = null;          // truthy when autoplay is running
		let currentIndex       = -1;          // last-open tooltip index (resume from here)
		const intervalDuration = 4000;

		// helpers
		function setButton() {
			if (!toggleBtn)
			{
				return;
			}

			if (intervalId)
			{
				toggleBtn.classList.add('pause');
				toggleBtn.classList.remove('play');
				toggleBtn.setAttribute('aria-label', toggleBtn.dataset.labelPause);
			}
			else
			{
				toggleBtn.classList.add('play');
				toggleBtn.classList.remove('pause');
				toggleBtn.setAttribute('aria-label', toggleBtn.dataset.labelPlay);
			}

			toggleBtn.ariaPressed = String(!!intervalId);
		}

		// Single source of truth for hotspot/tooltip state.
		// Pass a valid index to open that hotspot and close the rest.
		// Pass -1 (or any out-of-range value) to close all.
		function setActive(i) {
			hotspots.forEach((hotspot, idx) => {
				// skip items that don't have an attached tooltip
				if (!hotspot._tooltip)
				{
					return;
				}

				const isActive = idx === i;

				// open the selected one, close the others
				hotspot._tooltip.classList.toggle('open', isActive);
				hotspot.classList.toggle('open', isActive);

				// update progress UI
				hotspot._progress.style.setProperty('--progress', isActive ? '100' : '0');

				const playLabel  = hotspot.querySelector('.sr-play');
				const pauseLabel = hotspot.querySelector('.sr-pause');

				// toggle labels
				if (playLabel && pauseLabel)
				{
					playLabel.hidden  = isActive;
					pauseLabel.hidden = !isActive;
				}

				// Update ARIA and CSS state
				hotspot.ariaExpanded    = isActive;
				hotspot._tooltip.hidden = !isActive;
			});
		}

		function startCycle() {
			if (intervalId)
			{
				return; // already running
			}

			// if nothing opened yet, start from 0; otherwise resume from currentIndex
			if (currentIndex < 0)
			{
				currentIndex = 0;
			}

			setActive(currentIndex);

			intervalId = setInterval(() => {
				currentIndex = (currentIndex + 1) % hotspots.length;
				setActive(currentIndex);
			}, intervalDuration);

			setButton();
		}

		function stopCycle() {
			if (!intervalId)
			{
				return;
			}

			clearInterval(intervalId);
			intervalId = null;
			setButton();
		}

		// create tooltips and position them
		hotspots.forEach((hotspot, i) => {
			const placement = hotspot.dataset.placement || 'top-start';
			const tooltip   = document.getElementById(hotspot.getAttribute("aria-controls"));
			const progress  = hotspot.querySelector(".circular-progress");

			if (!tooltip)
			{
				return;
			}

			tooltip.classList.add(placement);

			hotspot._tooltip  = tooltip;
			hotspot._progress = progress;

			// position updater
			const update = () => {
				computePosition(hotspot, tooltip, {
					placement,
					middleware: [
						offset(({rects}) => ({
							mainAxis:      tooltipOffset,
							alignmentAxis: -rects.floating.width - tooltipOffset
						})),
						flip(), // allow flip on collision
						shift({padding: 0}) // keep inside
					]
				}).then(({x, y, placement: realPlacement}) => {
					tooltip.style.left = `${x}px`;
					tooltip.style.top  = `${y}px`;

					// Keep class in sync with final placement
					// Remove previous placement classes
					tooltip.classList.remove(
						'top-start',
						'top-end',
						'bottom-start',
						'bottom-end'
					);

					hotspot.classList.remove(
						'top-start',
						'top-end',
						'bottom-start',
						'bottom-end'
					);

					// Add the new one
					tooltip.classList.add(realPlacement);
					hotspot.classList.add(realPlacement);
				});
			};

			// keep it responsive
			autoUpdate(hotspot, tooltip, update);
			update();

			// user toggles tooltip by clicking box -> stop cycle and toggle open
			hotspot.addEventListener('click', (ev) => {
				ev.stopPropagation();

				// manual interaction pauses autoplay
				stopCycle();

				// toggle: close if already open, open otherwise
				const isOpen = hotspot.classList.contains('open');
				setActive(isOpen ? -1 : i);
			});
		});

		// outside click closes all and pauses
		document.addEventListener('click', () => {
			stopCycle();
			setActive(-1);
		});

		// escape closes all and pauses
		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape')
			{
				stopCycle();
				setActive(-1);
			}
		});

		// button control (always works)
		if (toggleBtn)
		{
			toggleBtn.addEventListener('click', (e) => {
				e.stopPropagation();
				intervalId ? stopCycle() : startCycle();
			});
		}

		// auto-start only if user doesn't prefer reduced motion
		if (!prefersReducedMotion)
		{
			startCycle();
		}
		else
		{
			setButton();
			setActive(0); // open the first tooltip
		}
	}

});